import React, { useState } from "react";
import useAuth from "../../hooks/useAuth";
import { Link, useNavigate } from "react-router";
import { IoLogoGoogle } from "react-icons/io";
import { useTranslation } from "react-i18next";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { signInWithEmail, signInWithGoogle, signInWithApple } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmail(email, password);
      handleSuccess();
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  const handleGoogle = async (e) => {
    e.preventDefault();
    try {
      await signInWithGoogle();
      handleSuccess();
    } catch (error) {
      console.error("Google login failed:", error);
    }
  };

  const handleApple = async (e) => {
    e.preventDefault();
    try {
      await signInWithApple();
      handleSuccess();
    } catch (error) {
      console.error("Apple login failed:", error);
    }
  };

  const handleSuccess = async () => {
    try {
      navigate("/users");
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  return (
    <>
      <video
        autoPlay
        loop
        muted
        playsInline
        className="fixed top-0 left-0 w-full h-full object-fill z-[-1]"
      >
        <source src={t("loginVideo")} type="video/mp4" />
        Seu navegador não suporta vídeo.
      </video>
      <div className="container no-scroll mx-auto">
        <div className="flex flex-col justify-end items-center h-full">
          <div className="scroll">
            <div>
              <div className="w-full h-40 object-contain" />

              <div className="mt-5 mb-10">
                <h2 className="text-3xl font-semibold text-center"></h2>
              </div>
            </div>
            <div className="pl-5 pr-5 pb-5">
              <input
                type="email"
                placeholder={t("email")}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full p-4 !bg-[#e2dedf] text-black rounded-xl mb-5"
              />
              <input
                type="password"
                placeholder={t("password")}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full p-4 !bg-[#e2dedf] text-black rounded-xl"
              />
              <div className="ms-5 me-5 mt-5">
                <button
                  onClick={handleLogin}
                  className="btn btn-small btn-brand w-full pt-3 pb-3 text-2xl leading-7"
                >
                  {t("loginConnect")}
                </button>
              </div>
              <div className="text-center mt-5">
                <Link className="font-medium" to="/register">
                  {t("loginNoAccount")}
                  <span className="text-[#DF5260]"> {t("loginCreateNow")}</span>
                </Link>
              </div>
              <div className="mt-6">
                <div className="h-[1px] bg-[#DF5260]"></div>
                <div className="relative flex justify-center items-center -top-3">
                  <span className="font-medium bg-[--gender-background] ps-2 pe-2">
                    {t("loginOrConnect")}
                  </span>
                </div>
              </div>
              <div className="flex justify-around items-center mt-2">
                <button
                  onClick={handleGoogle}
                  className="btn p-2 rounded-full bg-[#DF5260]"
                >
                  <IoLogoGoogle size={32} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
